// extracted by mini-css-extract-plugin
module.exports = {"container":"b1ddd01198--container--m_FeR","slider":"b1ddd01198--slider--AjUaw"};